const MANUAL_STATUS_EXCLUSIONS = new Set([
  'entrada',
  'analise',
  'finalizado',
  'cancelado',
]);

export const postSaleStatusOptions = t =>
  [
    { value: '', label: t('POST_SALE.STATUS.SELECT') },
    { value: 'entrada', label: t('POST_SALE.STATUS.ENTRY') },
    { value: 'analise', label: t('POST_SALE.STATUS.ANALYSIS') },
    { value: 'certidoes', label: t('POST_SALE.STATUS.CERTIFICATES') },
    { value: 'taxas', label: t('POST_SALE.STATUS.TAXES') },
    { value: 'itbi', label: t('POST_SALE.STATUS.ITBI') },
    {
      value: 'banco_documentacao',
      label: t('POST_SALE.STATUS.BANK_DOCUMENTATION'),
    },
    { value: 'engenharia', label: t('POST_SALE.STATUS.ENGINEERING') },
    {
      value: 'emissao_contrato',
      label: t('POST_SALE.STATUS.CONTRACT_ISSUANCE'),
    },
    { value: 'averbacao', label: t('POST_SALE.STATUS.ANNOTATION') },
    { value: 'laudemio', label: t('POST_SALE.STATUS.LAUDEMIUM') },
    { value: 'escritura', label: t('POST_SALE.STATUS.DEED') },
    { value: 'registro', label: t('POST_SALE.STATUS.REGISTRY') },
    { value: 'entrega_chaves', label: t('POST_SALE.STATUS.KEY_HANDOVER') },
    { value: 'correcao', label: t('POST_SALE.STATUS.CORRECTION') },
    { value: 'finalizado', label: t('POST_SALE.STATUS.FINISHED') },
    { value: 'cancelado', label: t('POST_SALE.STATUS.CANCELED') },
  ].filter(option => !MANUAL_STATUS_EXCLUSIONS.has(option.value));
